import { FC } from 'react';
import { ButtonProps } from '../../button/components/Button';
import { Button } from '../../button';

type ModalActionFooterProps = {
  className?: string;
  buttons: ButtonProps[];
};

const ModalActionFooter: FC<ModalActionFooterProps> = (props) => {
  return (
    <div
      className={`flex border-t border-gray-darkest border-opacity-10 flex-row-reverse justify-start items-center px-10 py-8 ${
        props.className ? props.className : ''
      }`}
    >
      {props.buttons.map((button, idx) => (
        <Button
          {...button}
          classes={['ml-6']}
          key={`${idx}__${button.label}`}
        />
      ))}
    </div>
  );
};

export default ModalActionFooter;
